window.addEventListener("load", function () {
  function loadCustomerPrivacyAPI(callback) {
    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      callback
    );
  }

  if (!window.location.href.includes("?sales_channel=venn_apps")) {
    loadCustomerPrivacyAPI((error) => {
      if (error) {
        console.error("Failed to load the consent tracking API:", error);
        return;
      }

      const privacySettings = {
        consentStatus: window.Shopify.customerPrivacy.currentVisitorConsent(),
        shouldDisplay: window.Shopify.customerPrivacy.shouldShowBanner(),
      };

      if (privacySettings.shouldDisplay && localStorage.getItem("cookies-banner-completed") === "true") {
        insiderInit(getCookiesStatus(privacySettings.consentStatus));
      } else if (privacySettings.shouldDisplay && localStorage.getItem("cookies-banner-completed") !== "true") {
        // Until the user selects one of the options – user object inisalization with gdpr: false
        insiderInit(getCookiesStatus({ analytics: "", marketing: "" }));

        waitForCookieDecision().then((consent) => {
          insiderInit(getCookiesStatus(consent));
        });
      } else {
        // For privacySettings.shouldDisplay === false
        insiderInit(getCookiesStatus({ analytics: "yes", marketing: "yes" }));
      }
    });
  }

  function getCookiesStatus(status) {
    return status.analytics === "yes" && status.marketing === "yes";
  }

  function waitForCookieDecision() {
    return new Promise((resolve) => {
      window.PubSub.subscribe("cookies-banner-completed", async () => {
        const consent = await window.Shopify.customerPrivacy.currentVisitorConsent();
        resolve(consent);
      });
    });
  }

  function insiderInit(hasCookieConsent) {
    window.insider_object = window.insider_object || {};
    const customerObject = { ...window.Shopify.customer, gdpr_optin: hasCookieConsent };
    window.insider_object.user = customerObject;
    let insiderScript = document.createElement("script");
    insiderScript.src = "https://nayomi2.api.useinsider.com/ins.js?id=10012648";
    insiderScript.setAttribute("defer", "");
    document.head.appendChild(insiderScript);
  }
});
